import { createContext, useContext } from 'react';

/**
 * Context to indicate whether the MFE is running in embedded mode.
 * When embedded, navigation should dispatch 'mfe-navigate' events to the host
 * instead of using the internal MemoryRouter history.
 */
export const EmbeddedModeContext = createContext<boolean>(false);

export const useEmbeddedMode = () => useContext(EmbeddedModeContext);
